import { t } from 'i18next';

export const actionMessage = (entity: string) => ({
  entity,
  createRecord: t('actionCreated'),
  updateRecord: t('actionUpdated'),
  removeRecord: t('actionRemoved'),
});

export const actionLoadingMessage = (entity: string) => ({
  entity: entity.toLowerCase(),
  createRecord: t('actionCreateInProgress'),
  updateRecord: t('actionUpdateInProgress'),
  removeRecord: t('actionRemoveInProgress'),
});
